<style lang="scss" src='./CreateTask.scss' scoped></style>
<template src="./CreateTask.html"></template>
<script>

import TaskDetailsComments from '@/components/comments/TaskDetailsComments.vue';
import CommonComponent from '@/components/utils/CommonComponent.vue';
import Header from '@/components/header/Header.vue';
import { GetHoles, GetZones, GetUsers, SaveTask, SaveTaskComment } from '@/api/api';
import { omit } from 'lodash';
import { mapMutations, mapState } from "vuex";
import { isEmpty } from 'lodash';
import MapRedFlag from '@/assets/img/gw/flags/ic_flag_red.png';

export default {
  name: 'CreateTask',
  extends: CommonComponent,
  components: {
    TaskDetailsComments,
    Header,
  },
  data() {
    return {
      holes: [],
      zones: [],
      users: [],
      comment: '',
      map: null,
      google: null,
      mapMarker: null,
      task: {},
      loading: {
        creatingTask: false,
      },
      emptyTaskAlert: false
    };
  },

  computed: {
    zonesFiltered: function fnZonesFiltered() {
      if (this.zones && this.zones.length) {
        if (this.task.hole_id === 'all') {
          return this.zones;
        } else if (this.task.hole_id === 'other') {
          return this.zones.filter((zone) => !zone.hole_linked);
        } else if (this.task.hole_id > 0) {
          return this.zones.filter((zone) => zone.hole_linked);
        }
      }
      return [];
    },
    ...mapState(["taskAlert"]),
    validCoordinates(){
      if(this.task.longitude && this.task.latitude && this.G_validateLatLong(this.task.latitude, this.task.longitude)){
        return true
      }
      return false
    },
  },

  methods: {
    ...mapMutations('TaskBoard', ['addNewTask']),

    getTaskBean(task) {
      return {
        description: task ? task.description : '',
        location_attached: task && task.latitude && task.longitude && this.G_validateLatLong(task.latitude, task.longitude) ? task.location_attached : false,
        latitude: task && task.latitude && this.G_validateLat(task.latitude) ? task.latitude : null,
        longitude: task && task.longitude && this.G_validateLong(task.longitude) ? task.longitude : null,
        hole_id: task ? task.hole_id : null,
        zone_id: task ? task.zone_id : null,
        assigned_to: task ? task.assigned_to : null,
        activities: task ? task.activities : [],
        alert_id: task && task.alert_id ? task.alert_id : null,
      };
    },

    async initMap({ lat = 0, lng = 0 }) {
      const mapOptions = {
        mapId: 'map',
        zoom: 0,
        center: { lat, lng },
        controlOptions: {
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
        },
      };
      this.map = await this.G_initMap(mapOptions);
      this.google = this.consts.Google.MAP;
    },

    useCurrentLocation() {
      if (this.task.location_attached) {
        this.G_findCurrentLocation(this.setTaskLocation);
      } else {
        this.setTaskLocation({ lat: null, lng: null });
      }
    },

    async setTaskLocation({ lat, lng }) {
      this.task.latitude = lat;
      this.task.longitude = lng;
    },

    loadHoles() {
      GetHoles().then((res) => {
        if (res.holes) {
          this.holes = res.holes;
        }
      });
    },

    loadZones() {
      GetZones().then((res) => {
        if (res.zones) {
          this.zones = res.zones; 
        };
      });
    },

    loadUsers() {
      GetUsers().then((res) => {
        if (res.users) {
          this.users = res.users; 
        }
      });
    },

    onLocationChange() {
      this.task.zone_id = null;
    },

    addComment() {
      if (this.comment) {
        this.task.activities.unshift({
          comment: this.comment,
          type: this.consts.TaskActivityType.COMMENT,
          time_created: new Date(),
          user: this.$store.state.user,
        });
        this.comment = '';
      }
    },

    async createTask() {
      const validForm = await this.$refs.validator.validate().then((v) => v);
      if (validForm) {
        this.loading.creatingTask = true;
        const task = omit(this.task, ['activities']);
        
        task.all_holes = (task.hole_id == 'all') ? true : false;
        task.hole_id = (task.hole_id == 'other' || task.hole_id == 'all') ? null : task.hole_id;
        task.course_id = this.$store.state.course.course_id;
        SaveTask(task).then(async (taskSaved) => {
          if (this.task.activities.length) {
            let activitiesSaved = [];
            const commentsToSave = this.task.activities.filter((activity) => !activity.activity_id).reverse();
            for (let index = 0; index < commentsToSave.length; index++) {
              const activityData = omit(commentsToSave[index], ['time_created', 'user']);
              activityData.task_id = taskSaved.task_id;
              const activitySaved = await SaveTaskComment(activityData);
              activitiesSaved.unshift(activitySaved);
            }
              
            if (activitiesSaved.length) {
              taskSaved.activities.unshift(...activitiesSaved);
            }
          }
          this.loading.creatingTask = false;
          this.addNewTask(taskSaved);
          this.setShowMenu(true);
          this.setShowBackground(true);
          this.$router.push('/task-board');
        });
      }
    },

    getTaskTemplate(){
      return !isEmpty(this.taskAlert) ? this.getTaskBean(this.taskAlert) : this.getTaskBean()
    },

    checkValidTaskAlert(){
      this.emptyTaskAlert = isEmpty(this.taskAlert)
    },
    setTaskLocation({ lat, lng }) {
      this.task.latitude = lat;
      this.task.longitude = lng;
    },
  },

  beforeMount(){
    this.setShowBackground(false);
    this.setShowMenu(false);
  },

  async mounted(){
    this.loadHoles();
    this.loadZones();
    this.loadUsers();
    this.checkValidTaskAlert();
    this.task = await this.getTaskTemplate();
    await this.initMap({ lat: this.task.latitude ? this.task.latitude :0, lng: this.task.longitude ? this.task.longitude :0 });
    //this.reset
    const mapIcon = this.task.alert_id ? MapRedFlag : null;
    if (this.task.location_attached) {
        this.G_addMarkerToMap({lat: this.task.latitude, lng: this.task.longitude}, mapIcon, this.setTaskLocation);
    }
    if (!this.task.hole_id && this.task.zone_id && this.task.all_holes){
      this.task.hole_id = 'all';
    }else if (!this.task.hole_id && this.task.zone_id){
      this.task.hole_id = 'other';
    }
  },

}

</script>
